import { RHFCode } from './rhf-code';
import { RHFRating } from './rhf-rating';
import { RHFSlider } from './rhf-slider';
import { RHFSpotlights } from './rhf-spotlights';
import { RHFRadioGroup } from './rhf-radio-group';
import { RHFAutocomplete } from './rhf-autocomplete';
import { RHFSwitch, RHFMultiSwitch } from './rhf-switch';
import { RHFSelect, RHFMultiSelect } from './rhf-select';
import { RHFCheckbox, RHFMultiCheckbox } from './rhf-checkbox';
import { RHFTextField, RHFTimeTextField } from './rhf-text-field';
import { RHFDatePicker, RHFDateTimePicker } from './rhf-date-picker';
import {
  RHFUploadBox,
  RHFUploadVideo,
  RHFUploadImage,
  RHFUploadAudio,
  RHFUploadAvatar,
} from './rhf-upload';

// ----------------------------------------------------------------------

export const Field = {
  Code: RHFCode,
  Select: RHFSelect,
  UploadVideo: RHFUploadVideo,
  UploadImage: RHFUploadImage,
  Switch: RHFSwitch,
  Slider: RHFSlider,
  Rating: RHFRating,
  Text: RHFTextField,
  Checkbox: RHFCheckbox,
  UploadBox: RHFUploadBox,
  RadioGroup: RHFRadioGroup,
  MultiSelect: RHFMultiSelect,
  MultiSwitch: RHFMultiSwitch,
  UploadAvatar: RHFUploadAvatar,
  UploadAudio: RHFUploadAudio,
  Autocomplete: RHFAutocomplete,
  MultiCheckbox: RHFMultiCheckbox,
  DatePicker: RHFDatePicker,
  DateTimePicker: RHFDateTimePicker,
  TimeTextField: RHFTimeTextField,
  Spotlights: RHFSpotlights,
};
